export enum EPageType {
  Listing = 'Listing',
  ListingJK = 'ListingJK',
  Card = 'Card',
  CardJK = 'CardJK',
  Other = 'Other',
  Home = 'Home',
  HomeSuburban = 'HomeSuburban',
  ListingFavorites = 'ListingFavorites',
}
